export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#36B0DC',
    light: '#F7F8F8',
    after: '#6B5A9A',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#FFFFFF',
    light: 'rgba(255, 255, 255, 0.2)',
    contrastText: '#22211F',
  },
  text: {
    brand: '#003F2A',
    primary: '#001A11',
    secondary: '#3E444E',
    tertiaryLight: '#49515B',
    tertiary: '#0F0F0F',
    alternate: '#1F3B61',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    contrastText: '#22211F',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    brandLight: '#003964',
    fill: '#FAFAFA',
    hero1: '#002015B2',
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: '#4E4E4E',
    footer: '#07334A',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#0A4F8F',
    tableSubhead: '#F2F8FD',
    tableBorder: '#7D808880',
    tableAlternate: '#FFFFFF',
    alternate: '#E5EAF4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#B6BFA5',
    secondary: '#F5F3F0',
    light: '#EDE7DE',
    secondaryLight: 'rgba(238, 246, 250, 0.6)',
    primaryLight: '#D9EDF7',
    ribbon: '#BBE6FE',
    offer: '#D7FFF7',
    stepperCompleted: '#081425',
    border: '#D7DBE0',
    dark:'#0A4F8F',
  },
  surface: {
    light: '#B6BFA5',
    grey: '#FAFAFA',
    pricing: '#E7F3FD',
    learnMore: '#F4F4F4',
    header: '#FAFAFA',
    planCard: '#F7F8F8',
    switch: '#313E50',
  },
  verticalBar: {
    used: '#687462',
    unused: '#F6F6F6',
    unlimited: '#C0C0C0',
  },
};
